<template>
<div class="share_wrap">
        <transition :name="transition" v-if="showShare">
            <div v-if="!loadSuccess" class="error-view">
                <!-- <svg-icon icon-class="error-load" class="error-icon"></svg-icon> -->
                <span>{{$t("加载失败，请刷新后重试")}}</span>
                <div class="error-refresh-btn" @click="reload">{{$t("刷新")}}</div>
            </div>
            <div v-else class="popover-share">
                <div class="share-view" v-if="!showAddAuthView">
                    <div class="popover-share-content">
                        <div class="popover-share-top">
                            <div class="popover-share-top-title">
                                <div class="title">                                    {{myAuth === "ALL" || myAuth === "WRITE" && isCreator ? $t("权限管理") : $t("查看协作者")}}                                </div>
                                <div class="recover-content" v-show="(myAuth === 'ALL' || (myAuth === 'WRITE' && isCreator)) && !inheritedAuth">
                                    <div class="recover-title">{{$t("已单独设置权限，其他页面修改权限不影响本页面")}}                                    </div>
                                    <div class="recover-btn" @click.stop="recoverAuth">{{$t("恢复")}}                                    </div>
                                </div>
                            </div>
                            <div class="set-and-close">
                                <FileShareCopySetting v-if="isShowCopySetting" :fileId="fileId"></FileShareCopySetting>
                                <div class="close-btn" @click.stop="closeShareView">
                                    <img src="@/assets/img/share/icon_file_close.png"/>
                                </div>
                            </div>
                        </div>

                        <div class="popover-share-center">
                            <div class="popover-share-center-top">
                                <div class="popover-share-center-top-title">
                                    {{ topTitle }}
                                </div>
                                <!-- <div v-if="myAuth === 'ALL'" class="popover-share-center-top-btn" @click="enterManagerView">
                  <img src="@/assets/img/share/icon_file_add_worker.png" />
                  {{ addWorkTitle }}
                </div> -->
                                <div v-if="myAuth !== 'ALL'" class="apply-auth-btn" @click="applyMoreAuth">{{$t("申请更多权限")}}                                </div>
                            </div>
                            <div v-if="myAuth === 'ALL'" ref="inputContainer" class="popover-share-search" @mouseenter="hoverInput(true)" @mouseleave="hoverInput(false)">
                                <div class="member-input">
                                    <a-trigger class="share-member-search-trigger" position="bl" trigger="focus" v-model="searchText" :click-outside-to-close="false" :blur-to-close="false">
                                        <div ref="searchInput" class="search-input" contenteditable="true" :data-placeholder="$t('搜索用户添加权限')" @input="searchMembers" @focus="searchInputFocus" @blur="handleBlur" @keydown="handleKeyDown"></div>
                                        <template #content>
                                            <FileShareSearchView v-show="showSearchResult" :width="'368px'" :searchText="searchText" :originData="shareList" @selectMember="selectMember"></FileShareSearchView>
                                        </template>
                                    </a-trigger>
                                    <div v-show="searchText" class="clear-btn" @click.stop="clearText">
                                        <svg-icon name="header-file_transfer_input_clear" class="clear-icon"></svg-icon>
                                    </div>
                                </div>

                                <a-tooltip position="bottom" :content="$t('添加协作者')" popup-container="#main_view" content-class="custom_tooltip_css" arrow-class="custom_tooltip_css_arrow">
                                    <div class="popover-share-search-add-member-btn" @click="enterManagerView">
                                        <svg-icon name="share-share_add_member" style="width: 16px; height: 16px"></svg-icon>
                                    </div>
                                </a-tooltip>
                            </div>
                            <div class="popover-share-center-worker">
                                <FileShareManageView :fileId="fileId" :myAuth="myAuth" :nonAdminMaxAuth="currentNonAdminMaxAuth" :shareAuthList="shareList" :userInfo="userInfo" @updateMemberAuthList="updateMemberAuthList"></FileShareManageView>
                            </div>
                            <div class="popover-share-center-title">{{$t("链接分享范围")}}                                <a-tooltip position="tl" :content="$t('已分配权限的协作者，无论链接分享范围如何设置，均按已分配的权限访问。')" popup-container="#main_view" content-class="share-link-range-tip-class" arrow-class="custom_tooltip_css_arrow">
                                    <span class="share-tip-entry"><svg-icon name="share-share_greyTips"></svg-icon></span>
                                </a-tooltip>
                            </div>
                            <div id="link_share_range_set_share_view"></div>
                        </div>
                    </div>

                    <div class="popover-share-bottom">
                        <div class="popover-share-bottom-copy-btn" @click="getShareUrl">
                            <img src="@/assets/img/share/icon_file_copy_link.png"/>{{$t("复制链接")}}                        </div>
                    </div>
                </div>

                <FileShareAddConfirmView v-if="showAddAuthView" :fileId="fileId" :myAuth="myAuth" :nonAdminMaxAuth="currentNonAdminMaxAuth" :spaceId="userInfo.spaceId" :addData="shouldAddData" :originData="shareList" :contentType="contentType" @backToManageView="backFromManageView"></FileShareAddConfirmView>
                <div v-if="inManagerView" id="invite-view-container"></div>
            </div>
        </transition>
        <div ref="popoverSlot">
            <slot name="reference"></slot>
        </div>
        <a-modal class="apply-dialog" v-model:visible="showApplyDialog" :simple="true" :footer="false">
            <ApplyAuthView v-if="showApplyDialog" :nonAdminMaxAuth="currentNonAdminMaxAuth" :isDialog="true" :auth="myAuth" :fileId="fileId" :message="applyMessage" :owner="creator" :contentType="contentType" @apply-success="applySuccess"></ApplyAuthView>
        </a-modal>
        <a-modal class="file-share-common-dialog" v-model:visible="showRecoverDialog" :simple="true" :footer="false" :render-to-body="false">
            <div class="content">
                <div class="title">
                    <img src="@/assets/img/share/icon_file_tip.png"/>{{$t("权限变更")}}                </div>
                <div class="desc">{{$t("恢复后，当前页面权限会和父页面保持一致，此后父页面的新增、删除、修改权限，均会影响到本页面，是否继续？")}}                </div>
                <div class="bottom">
                    <div class="cancel-btn" @click="showRecoverDialog = false">{{$t("取消")}}                    </div>
                    <div class="confirm-btn" @click="recoverConfirm">{{$t("确认")}}</div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import {
getShareInfo,
getShareAuthList,
getShareUrl,
deleteAuth,
recoverAuth,
nonAdminMaxAuth } from
'../../core/api/file';
import FileShareAvatar from './FileShareAvatar.vue';
import FileShareManageView from './FileShareManageView.vue';
import FileShareAddConfirmView from './FileShareAddConfirmView.vue';
import ApplyAuthView from './ApplyAuthView.vue';
import FileShareSearchView from './FileShareSearchView.vue';
import { store } from '../../store/store';
import { mapActions, mapState } from 'vuex';
import { TocaWikiLinkShareRangeSet } from '@toca/toca-wiki-template';
import '@toca/toca-wiki-template/dist/style.css';
import { getShareAuthTip } from './shareUtil';
import FileShareCopySetting from './FileShareCopySetting.vue';

export default {
  name: 'FileShareView',
  components: {
    FileShareAvatar,
    FileShareManageView,
    ApplyAuthView,
    FileShareAddConfirmView,
    FileShareSearchView,
    FileShareCopySetting },

  props: {
    transition: {
      type: String,
      default: 'fade-in-linear' },

    showShare: {
      type: Boolean,
      default: false },

    reference: {},
    rightOffset: {
      type: Number,
      default: 0 },

    fileId: {
      type: String,
      default: '',
      required: true },

    fileUrl: {
      type: String,
      default: '',
      required: true },

    myAuth: {
      type: String },

    userInfo: {
      type: Object },

    sameSpace: {
      type: Boolean },

    creator: {
      type: String },

    creatorInfo: {
      type: Object } },


  watch: {
    myAuth: {
      handler(v) {
        this.initData();
      } },

    showShare: {
      handler(v) {
        if (v === false) {
          this.inManagerView = false;
          this.searchText = '';
        } else {
          this.popoverStyle = this.popoverShareStyle();
          this.$nextTick(() => {
            this.mountLinkShareRangeSet();
          });
          this.initData();
        }
      } },

    showAddAuthView: {
      handler(v) {
        if (v === false) {
          this.$nextTick(() => {
            this.mountLinkShareRangeSet();
          });
          this.initData();
        }
      } },

    shareList: {
      handler(v) {
        if (v.length !== 0) {
          this.configUserAndDepartData(v);
        }
      },
      deep: true,
      immediate: true } },


  data() {
    return {
      popoverStyle: '',
      popoverWidth: 400,
      addWorkTitle: intl.$t("添加协作者"),
      shareAuth: '',
      shareScope: '',
      shareList: [],
      inManagerView: false,
      loadSuccess: true,
      applyMessage: intl.$t("申请更多权限"),
      inviteUsersList: [],
      disableUserList: [],
      selectDepartList: [],
      selectGrouptList: [],
      selectImList: [],
      shouldAddData: [],
      showAddAuthView: false,
      inheritedAuth: true,
      showRecoverDialog: false,
      shareUrl: null,
      currentNonAdminMaxAuth: '',
      searchText: '',
      isFocus: false,
      selectedMember: null,
      showSearchResult: true,
      spaceInfo: null,
      tocaFinder: null,
      linkShareRangeSet: null };

  },
  emits: ['closeShareView', 'applyAuth', 'updateAuthInfos', 'updateLinkShareRange', 'onLinkRangeSetDropdownVisible', 'UpdateLinkShareRangeSet'],
  computed: {
    ...mapState({
      showApplyDialog: (state) => state.kbTreeNodeModule.showApplyDialog,
      shareAuthTip: (state) => state.kbEditModule.shareAuthTip,
      wikiI18n: (state) => state.kbModule.wikiI18n,
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo,
      doc_info: (state) => state.kbEditModule.doc_info }),

    contentType() {
      return this.doc_info?.fileInfo?.contentType || "";
    },
    isShowCopySetting() {
      if (
      this.myAuth === 'ALL' && (
      this.contentType === 'DOCUMENT' ||
      this.contentType === 'EXCEL' ||
      this.contentType === 'PPT' ||
      this.contentType === 'PDF' ||
      this.contentType === 'WORD'))
      {
        return true;
      }
      return false;
    },
    topTitle() {
      if (this.shareScope === 'COLLABORATOR') {
        return intl.$t("仅以下协作者可查看/编辑");
      }
      return this.myAuth !== 'ALL' ? intl.$t("协作者") : intl.$t("邀请协作者");
    },
    isCreator() {
      return (
        this.creatorInfo &&
        this.userInfo.userId === this.creatorInfo.userId &&
        this.userInfo.spaceId === this.creatorInfo.spaceId);

    } },

  mounted() {
    this.initData();

    setTimeout(() => {
      this.popoverStyle = this.popoverShareStyle();
    }, 200);
    window.addEventListener('resize', this.popoverResize);
    document.addEventListener(
    'visibilitychange',
    this.handleVisibilityChange);

  },
  unmounted() {
    window.removeEventListener('resize', this.popoverResize);
    document.removeEventListener(
    'visibilitychange',
    this.handleVisibilityChange);

    if (this.linkShareRangeSet) {
      this.linkShareRangeSet.destroy();
      this.linkShareRangeSet = null;
    }
  },
  methods: {
    ...mapActions({
      setApplyDialog: 'kbTreeNodeModule/setApplyDialog',
      setShareAuthTip: `kbEditModule/setShareAuthTip` }),

    updateShareInfo(auth, scope, fileId) {
      this.shareAuth = auth;
      this.shareScope = scope;
      if (this.linkShareRangeSet) {
        this.linkShareRangeSet.updateShareRangeInfo(auth, scope, null, '', {
          spaceId: this.wikiSpaceInfo?.id,
          spaceName: this.wikiSpaceInfo?.spaceName });

      }
      const tip = getShareAuthTip(auth, scope, this.spaceInfo);
      this.setShareAuthTip(tip);
    },
    mountLinkShareRangeSet() {
      try {
        const cookies = {
          token: store.state.userModule.token,
          spaceId: store.state.userModule.spaceId,
          userId: store.state.userModule.userId,
          deviceId: store.state.userModule.deviceId,
          memberUniqueId: store.state.userModule.userDetail?.id,
          memberId: store.state.userModule.userDetail?.id };

        this.linkShareRangeSet = new TocaWikiLinkShareRangeSet('#link_share_range_set_share_view', {
          locale: this.wikiI18n,
          env: import.meta.env.MODE,
          userInfo: cookies,
          onlyShowAuthDesc: false,
          isWiki: true,
          fileId: this.fileId,
          canUpdateLinkShareRange: this.canUpdateUrlAuth,
          shareAuth: '',
          shareScope: '',
          shareExpireDate: null,
          sharePassword: '',
          spaceInfo: this.spaceInfo,
          onUpdateShareRange: (auth, scope, expireDate, password, spaceInfo, shareAuthTip) => {
            console.log('V------------------------link_share_range_set_share_view-----------------');
            this.$emit('updateLinkShareRange', auth, scope, expireDate, password, spaceInfo, shareAuthTip);
          },
          onUpdateShareAuthTip: (tip) => {
            this.setShareAuthTip(tip);
          },
          onLinkRangeSetDropdownVisible: (domId, visible) => {
            this.$emit('onLinkRangeSetDropdownVisible', domId, visible);
          } });

      } catch (error) {
        console.error(intl.$t("TocaWikiLinkShareRangeSet 初始化失败:"), error);
      }
    },
    handleVisibilityChange() {
      if (
      document.hidden &&
      this.$refs.searchInput &&
      this.$refs.searchInput === document.activeElement)
      {
        this.$refs.searchInput.blur();
      }
    },
    popoverShareStyle() {
      let reference = this.reference || this.$refs.popoverSlot;
      if (!reference) {
        return {};
      }
      const targetRect = reference.getBoundingClientRect();
      const popoverTop = targetRect.height + 11 + 8;
      let directoryWidth =
      document.querySelector('.directory')?.clientWidth ?? 0;
      const popoverLeft =
      targetRect.left - (
      this.popoverWidth - targetRect.width) -
      this.rightOffset -
      directoryWidth;
      return {
        top: `${popoverTop}px`,
        left: `${popoverLeft}px`,
        width: `${this.popoverWidth}px` };

    },
    popoverResize(event: any) {
      this.popoverStyle = this.popoverShareStyle();
    },
    /// 初始化信息
    initData() {
      // 链接分享 - 获取链接分享信息
      this.getShareInfo();
      this.queryNonAdminMaxAuth();
    },
    /// 链接分享 - 获取链接分享信息
    async getShareInfo() {
      try {
        // console.log('当前文件ID：', this.fileId);
        const res = await getShareInfo(this.fileId);
        const { code, data, message }: any = res.data || {};
        // console.log('获取分享信息', res);
        if (code === 200) {
          if (data === null || data === undefined) {
            // 查询文件协作者列表
            this.queryShareAuthList();
            return;
          }
          const {
            auth,
            scope,
            expireDate,
            password,
            spaceInfo,
            memberAcl } =
          data;
          this.shareAuth = auth;
          this.shareScope = scope;
          this.spaceInfo = spaceInfo;
          this.canUpdateUrlAuth = memberAcl?.canUpdateUrlAuth;

          this.$emit('UpdateLinkShareRangeSet', this.canUpdateUrlAuth);
          this.$emit('updateLinkShareRange', auth, scope, expireDate, password, spaceInfo);
          if (this.linkShareRangeSet) {
            this.linkShareRangeSet.updateShareRangeInfo(auth, scope, expireDate, password, spaceInfo);
            this.linkShareRangeSet.UpdateLinkShareRangeSet(this.canUpdateUrlAuth);
          }

          //设置tip
          const tip = getShareAuthTip(auth, scope, spaceInfo);
          this.setShareAuthTip(tip);

          // 查询文件协作者列表
          this.queryShareAuthList();
        } else {
          this.loadSuccess = false;
        }
      } catch (error) {
        this.loadSuccess = false;
      }
    },
    queryNonAdminMaxAuth() {
      nonAdminMaxAuth(this.fileId).
      then((res: any) => {
        const { code, data, message }: any = res.data || {};
        if (code === 200 && data !== null) {
          this.currentNonAdminMaxAuth = data;
        }
      }).
      catch((error) => {});
    },
    /// 查询文件协作者列表
    async queryShareAuthList() {
      const fileId = this.fileId;
      getShareAuthList(fileId).
      then((res: any) => {
        const { code, data, message }: any = res.data || {};
        if (code === 200 && data !== null) {
          const { inheritedAuth, authInfos, shareUrl } = data;
          this.inheritedAuth = inheritedAuth;
          this.shareList = authInfos;
          this.$emit('updateAuthInfos', authInfos);
          this.loadSuccess = true;
        } else {
          this.loadSuccess = false;
        }
      }).
      catch((error) => {
        this.loadSuccess = false;
      });
    },
    updateMemberAuthList() {
      this.queryShareAuthList();
    },
    /// 申请更多权限
    applyMoreAuth() {
      this.closeShareView();
      // this.$emit('applyAuth');
      // this.showApplyDialog = true;
      this.setApplyDialog(true);
    },
    applySuccess() {
      this.setApplyDialog(false);
    },
    /// 关闭分享视图
    closeShareView() {
      this.$emit('closeShareView', false);
    },
    /// 管理/查看协作者
    enterManagerView() {
      this.inManagerView = !this.inManagerView;
      setTimeout(async () => {
        await import('@toca/toca-finder/dist/style.css');
        const { TocaFinder } = await import('@toca/toca-finder');

        const params = {
          locale: this.wikiI18n,
          envConfig: import.meta.env.MODE,
          // envConfig: 'test',
          selectTitle: intl.$t("添加协作者"),
          confirmTitle: intl.$t("下一步"),
          maxNum: 9999,
          maxNumNotiy: intl.$t("协作者人数已达上限"),
          confirmEmpty: false,
          showUserGroup: true,
          showIMGroup: true,
          selectImList: this.selectImList,
          isShowUnitedSpaces: true,
          selectGroupList: this.selectGrouptList,
          selectUserList: this.inviteUsersList,
          selectUsersDisabled: this.disableUserList,
          selectDepartList: this.selectDepartList,
          closeOnClickModal: false,
          show: this.inManagerView,
          modal: true,
          checkStrictly: true,
          userId: store.state.userModule.userId,
          spaceId: store.state.userModule.spaceId,
          token: store.state.userModule.token,
          deviceId: store.state.userModule.deviceId,
          memberId: store.state.userModule.userDetail?.id,
          handerConfirmCallback: this.inviteConfirm,
          handerCloseCallback: this.closeInviteView };

        this.tocaFinder = new TocaFinder(
        '#invite-view-container',
        params);

      }, 0);
    },
    /// 获取分享链接
    getShareUrl() {
      this.createCopyArea(this.fileUrl);
    },
    createCopyArea(url: string) {
      navigator.clipboard.
      write([
      new ClipboardItem({
        'text/plain': new Blob([url], { type: 'text/plain' }) })]).


      then(() => {
        // console.log("HTML copied to clipboard");
        if (this.shareScope === 'COLLABORATOR') {
          this.$message.success(intl.$t("链接已复制，仅协作者可查看，请确认对方是否为协作者"));


        } else {
          const tip = getShareAuthTip(this.shareAuth, this.shareScope, this.spaceInfo, false);
          this.$message.success(intl.$t(`链接已复制，{tip}`, { tip: tip }));
        }
      }).
      catch((err) => {
        console.error('Failed to copy HTML: ', err);
        this.$message.error(intl.$t("链接复制失败"));
      });
    },
    reload() {
      this.initData();
    },
    backFromManageView() {
      this.updateMemberAuthList();
      this.showAddAuthView = !this.showAddAuthView;
    },
    configUserAndDepartData(originData: any[]) {
      this.disableUserList = [];
      this.selectDepartList = [];
      this.inviteUsersList = [];
      this.selectGrouptList = [];
      this.selectImList = [];
      originData.forEach((item) => {
        if (
        item.edit === false ||
        item.memberIdentity === 'ADMIN' ||
        item.memberIdentity === 'MEMBER')
        {
          if (item.toType === 'PERSON') {
            this.disableUserList.push({
              userId: item.to,
              type: 0,
              spaceId: item.toSpace,
              memberName: item.toName,
              memberAvatar: item.toAvatar,
              spaceName: item.toSpaceName });

          } else {
            this.disableUserList.push({
              departmentId: item.to,
              type: 1,
              spaceId: item.toSpace,
              departmentName: item.toName,
              spaceName: item.toSpaceName });

          }
        }
        if (item.toType === 'DEPARTMENT') {
          this.selectDepartList.push({
            departmentId: item.to,
            type: 1,
            spaceId: item.toSpace,
            departmentName: item.toName,
            spaceName: item.toSpaceName });

        }
        if (
        item.toType === 'PERSON' &&
        item.memberIdentity !== 'ADMIN' &&
        item.memberIdentity !== 'MEMBER' &&
        item.edit)
        {
          this.inviteUsersList.push({
            userId: item.to,
            type: 0,
            spaceId: item.toSpace,
            memberName: item.toName,
            memberAvatar: item.toAvatar,
            spaceName: item.toSpaceName });

        }
        if (item.toType === 'USER_GROUP') {
          this.selectGrouptList.push({
            type: 2,
            name: item.toName,
            description: item.toName,
            ...item,
            id: item.to });

        }

        if (item.toType === 'GROUP') {
          this.selectImList.push({
            type: 3,
            avatar: item.toAvatar,
            chatAvatar: item.toAvatar,
            chatName: item.toName,
            name: item.toName,
            ...item,
            id: item.to });

        }
      });
    },
    async inviteConfirm(addData: any[], allData: any[], reduceData: any[]) {
      if (addData.length === 0 && reduceData.length === 0) {
        this.inManagerView = false;
        return;
      }
      if (reduceData.length > 0) {
        for (const {
          type,
          userId,
          departmentId,
          id,
          spaceId } of
        reduceData) {
          let to = '';
          switch (type) {
            case 0:
              to = userId;
              break;
            case 1:
              to = departmentId;
              break;
            case 2:
              to = id;
              break;
            case 3:
              to = id;
              break;}

          const member = this.shareList.find((item: any) => {
            if (type !== 2 && type !== 3) {
              return item.to === to && item.toSpace === spaceId;
            } else {
              return item.to === to;
            }
          });
          if (member == null) continue;
          await deleteAuth(
          member.to,
          false,
          this.fileId,
          member.toSpace,
          member.toType);

        }
        this.updateMemberAuthList();
      }

      if (addData.length > 0) {
        this.shouldAddData = addData;
        this.showAddAuthView = true;
      }
    },
    closeInviteView() {
      this.inManagerView = false;
    },
    recoverAuth() {
      this.showRecoverDialog = true;
    },
    recoverConfirm() {
      recoverAuth(this.fileId).
      then((res: any) => {
        const { code, message }: any = res.data || {};
        if (code === 200) {
          this.$message.success(intl.$t("权限恢复成功"));
          this.updateMemberAuthList();
          this.showRecoverDialog = false;
        } else {
          this.$message.error(intl.$t(`权限恢复失败，{message}`, { message: message }));
        }
      }).
      catch((err) => {
        this.$message.error(intl.$t(`权限恢复失败，请重试`));
      });
    },
    hoverInput(isHover: boolean) {
      if (isHover) {
        this.inputContainerBorderStyle(true);
      } else {
        if (!this.isFocus) {
          this.inputContainerBorderStyle(false);
        }
      }
    },
    selectMember(item: any) {
      this.showSearchResult = false;
      this.selectedMember = item;
      this.$refs.searchInput.innerText = this.searchText = '';
      this.inputContainerBorderStyle(false);
      this.isFocus = false;

      let isOwner: boolean = false;
      let isAdmin: boolean = false;
      let exsitMember: any = this.shareList.find((member: any) => {
        if (
        member.toSpace === item.spaceId &&
        member.to === item.userId && (
        member.memberIdentity === 'ADMIN' ||
        member.memberIdentity === 'OWNER'))
        {
          if (member.memberIdentity === 'ADMIN') {
            isAdmin = true;
          } else if (member.memberIdentity === 'OWNER') {
            isOwner = true;
          }
        }
        return (
          member.toSpace === item.spaceId && member.to === item.userId);

      });

      if (exsitMember) {
        if (isOwner) {
          this.$message.warning(intl.$t("该用户为文档所有者，请勿重复添加"));
          return;
        } else if (isAdmin) {
          this.$message.warning(intl.$t("该用户为管理员，请勿重复添加"));
          return;
        }
      }
      this.shouldAddData = [];
      let defaultAuth = "READ_DOWNLOAD";
      if (
      this.contentType === 'DOCUMENT' ||
      this.contentType === 'EXCEL' ||
      this.contentType === 'PPT' ||
      this.contentType === 'PDF' ||
      this.contentType === 'WORD') {
        defaultAuth = 'READ';
      }

      this.shouldAddData.push({
        memberName: item.memberName,
        memberAvatar: item.memberAvatar,
        memberUniqueId: item.id,
        spaceId: item.spaceId,
        type: 0,
        userId: item.userId,
        spaceName: item.spaceName,
        auth: exsitMember ? exsitMember.auth : defaultAuth });

      this.showAddAuthView = true;
    },
    searchMembers(event) {
      this.selectedMember = null;
      this.showSearchResult = true;
      this.searchText = event.target.innerText;
    },
    searchInputFocus() {
      this.isFocus = true;
      this.inputContainerBorderStyle(true);
      this.handleRange();
    },
    handleRange() {
      this.$nextTick(() => {
        const range = document.createRange();
        const sel = window.getSelection();
        this.$refs.searchInput.focus();
        const childNodes = this.$refs.searchInput.childNodes;
        if (childNodes.length > 0) {
          const lastNode = childNodes[childNodes.length - 1];
          range.setStart(lastNode, lastNode.length || 0);
          range.collapse(true);
          sel?.removeAllRanges();
          sel?.addRange(range);
        }
      });
    },
    handleBlur() {
      this.isFocus = false;
      if (this.searchText) {
        this.inputContainerBorderStyle(false);
        setTimeout(() => {
          this.showSearchResult = false;
        }, 200);
      } else {
        this.inputContainerBorderStyle(false);
      }
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    },
    clearText() {
      this.$refs.searchInput.innerText = this.searchText = '';
      this.$refs.searchInput.focus();
    },
    inputContainerBorderStyle(hasBorder: boolean) {
      if (hasBorder) {
        this.$refs.inputContainer.style.border = '1px solid #5C70FF';
      } else {
        this.$refs.inputContainer.style.border = '1px solid #A2A4B0';
      }
    } },

  destory() {
    window.removeEventListener('resize', this.resize);
  },
  beforeUnmount() {
    document.removeEventListener(
    'visibilitychange',
    this.handleVisibilityChange);

  } };
</script>

<style lang="scss" scoped>
.share_wrap {
    position: relative;
}

.error-view {
    top: 32px;
    right: 0;
    width: 400px;
    position: absolute;
    z-index: 2000;
    background-color: #fff;
    border-radius: 10px;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    min-height: 316px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .error-icon {
        width: 108px;
        height: 108px;
        margin-bottom: 17px;
    }

    span {
        color: #a2a4b0;
        font-size: 14px;
        font-weight: 400;
        line-height: auto;
        letter-spacing: 0;
        text-align: center;
    }

    .error-refresh-btn {
        color: #5c70ff;
        font-size: 14px;
        font-weight: 400;
        line-height: auto;
        letter-spacing: 0;
        text-align: center;
        cursor: pointer;
    }
}

.popover-share {
    top: 32px;
    right: 0;
    width: 400px;
    position: absolute;
    z-index: 2000;
    background-color: #fff;
    border-radius: 10px;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    min-height: 312px;
    display: flex;
    flex-direction: column;

    .share-view {
        display: flex;
        flex-direction: column;

        .popover-share-content {
            display: flex;
            flex-direction: column;
            flex: 1;
            margin: 16px 16px 0px 16px;

            .popover-share-top {
                position: relative;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                line-height: 100%;
                margin-bottom: 24px;

                .popover-share-top-title {
                    display: flex;
                    flex: 1;
                    flex-direction: column;

                    .title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #121317;
                        line-height: 24px;
                    }

                    .recover-content {
                        margin-top: 8px;
                        height: 34px;
                        padding: 0 12px;
                        border-radius: 8px;
                        background: #eceeff;
                        display: flex;
                        flex: 1;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        box-shadow: none;
                        border: none;

                        .recover-title {
                            margin: 7px 0px;
                            color: #646a73;
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 20px;
                        }

                        .recover-btn {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: 20px;
                            padding: 0 2px;
                            border-radius: 6px;
                            font-weight: 400;
                            font-size: 14px;
                            color: #6C7CFF;
                            background-color: #ffffff;
                            letter-spacing: 0;
                            cursor: pointer;
                        }
                    }
                }

                .set-and-close {
                    position: absolute;
                    right: 0px;
                    top: 0px;
                    display: flex;
                    flex-direction: row;
                    .close-btn {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 24px;
                        height: 24px;
                        cursor: pointer;

                        img {
                            width: 14px;
                            height: 14px;
                            object-fit: contain;
                        }

                        &:hover {
                            background-color: #f4f6f9;
                            border-radius: 4px;
                        }
                    }
                }
            }

            .popover-share-center {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                margin-bottom: 16px;

                .popover-share-center-top {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    width: 100%;
                    margin-bottom: 16px;

                    .popover-share-center-top-title {
                        display: flex;
                        flex: 1;
                        font-size: 14px;
                        font-weight: 500;
                        font-family: PingFangSC-Medium;
                        color: #323233;
                        line-height: 20px;
                    }

                    .apply-auth-btn {
                        border-radius: 6px;
                        padding: 2px 8px;
                        background-color: #ffffff;
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 14px;
                        color: #5d71ff;
                        letter-spacing: 0;
                        cursor: pointer;

                        &:hover {
                            background-color: #f5f6f7;
                        }
                    }

                    .popover-share-center-top-btn {
                        cursor: pointer;
                        font-size: 14px;
                        font-weight: 300;
                        font-family: PingFangSC-Regular;
                        line-height: 20px;
                        color: #5d71ff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 2px 8px;

                        img {
                            width: 12px;
                            height: 12px;
                            margin-right: 4px;
                        }

                        &:hover {
                            background-color: #f4f6f9;
                            border-radius: 6px;
                        }
                    }
                }

                .popover-share-search {
                    margin-bottom: 8px;
                    width: 100%;
                    height: 32px;
                    box-sizing: border-box;
                    border: 1px solid #A2A4B0;
                    border-radius: 6px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;

                    .member-input {
                        width: 100%;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        position: relative;

                        .search-input {
                            display: inline-flex;
                            flex: 1;
                            padding: 6px 12px;
                            background: transparent;
                            border: none;
                            font-family: PingFangSC-Regular;
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 20px;
                            color: #121317;
                            text-align: left;

                            &:empty::before {
                                content: attr(data-placeholder);
                                font-family: PingFangSC-Regular;
                                font-weight: 400;
                                font-size: 14px;
                                color: #8f959e;
                                letter-spacing: 0;
                                line-height: 20px;
                                cursor: text;
                            }

                            &:focus-visible {
                                outline: none;
                            }
                        }

                        .clear-btn {
                            width: 16px;
                            height: 16px;
                            padding-right: 12px;
                            display: flex;
                            cursor: pointer;

                            .clear-icon {
                                width: 16px;
                                height: 16px;
                            }
                        }
                    }

                    .popover-share-search-add-member-btn {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 30px;
                        height: 30px;
                        cursor: pointer;
                        border-left: 1px solid #A2A4B0;
                        border-radius: 0 6px 6px 0;

                        &:hover {
                            background: #edeeee;
                        }
                    }
                }

                .popover-share-center-worker {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    width: 100%;
                    min-height: 40px;
                    max-height: 325px;
                    margin-bottom: 24px;

                    &::-webkit-scrollbar {
                        display: none;
                    }
                }

                .popover-share-center-title {
                    font-size: 14px;
                    font-weight: 500;
                    font-family: PingFangSC-Medium;
                    color: #323233;
                    line-height: 20px;
                    margin-bottom: 16px;

                    .share-tip-entry {
                        cursor: pointer;
                        width: 12px;
                        height: 12px;
                    }
                }

                #link_share_range_set_share_view {
                    width: 100%;
                }
            }
        }

        .popover-share-bottom {
            height: 52px;
            width: 100%;
            background-color: #f5f6f7;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            border-radius: 0 0 10px 10px;

            .popover-share-bottom-copy-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 16px;
                cursor: pointer;
                font-size: 14px;
                font-weight: 300;
                font-family: PingFangSC-Regular;
                color: #fff;
                line-height: 20px;
                background-color: #5c70ff;
                width: 100px;
                height: 36px;
                border-radius: 8px;

                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }

                &:hover {
                    background-color: #6d7dff;
                }
            }
        }
    }
}

.fade-in-linear-enter-active,
.fade-in-linear-leave-active {
    transition: opacity 200ms linear;
}

.fade-in-linear-enter,
.fade-in-linear-leave,
.fade-in-linear-leave-active {
    opacity: 0;
}
</style>

<style lang="scss">
@import './theme/commonDialog.scss';

.share-member-search-trigger {
    z-index: 5003 !important;
}

.dropdown-auth {
    z-index: 3001 !important;

    .arco-dropdown {
        margin-top: 0px !important;
        margin-left: 34px !important;
        padding: 0 !important;
        background: #ffffff !important;
        border: 1px solid #e6e8ec !important;
        box-shadow: 0 8px 12px 0 #1213171a !important;
        border-radius: 8px !important;
        width: 270px !important;

        .share-scope-list {
            width: 268px;
        }
    }

    .arco-dropdown-option {
        height: 28px !important;
        padding: 0 !important;
        margin: 4px 4px !important;
        display: flex !important;
        flex-direction: row !important;
        align-items: center !important;
        justify-content: flex-start !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        color: #333333 !important;
        cursor: pointer;
        width: 260px;

        .arco-dropdown-option-content {
            width: 100%;
            display: flex !important;
            flex-direction: row !important;
            align-items: center !important;
            justify-content: flex-start !important;

            .share-scope-list-name {
                flex: 1;
                margin: 0 5px;
                white-space: normal;
                line-height: 1;
            }

            img {
                width: 15px;
                height: 11px;
                margin-right: 11px;
            }
        }

        &:not(.arco-dropdown-option-disabled):hover {
            background-color: #f4f6f9 !important;
            border-radius: 8px !important;
        }
    }

    .arco-scrollbar-track {
        display: none;
    }
}

.apply-dialog {
    .arco-modal {
        width: 432px;
        height: 477px;
        padding: 0;
        border-radius: 16px;

        .arco-modal-header {
            display: none;
        }
    }
}


.share-link-range-tip-class {
    max-width: 256px !important;
    border-radius: 8px !important;
    color: #767c85 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    padding: 8px !important;
    background-color: #ffffff !important;
    box-shadow: 0 8px 12px 0 #1213171a !important;
}
</style>
